import Tooltip from 'components/tooltip/Tooltip'
import PropTypes from 'prop-types'

const TrackerServiceNames = ({ title, data }) => (
  <>
    <strong className="tit_tooltip">{title}</strong>
    <ul className="list_tooltip">
      {data.map(({ targetKey, targetKeyDesc }) => (
        <li key={targetKey}>
          <span className="ico_dot" />
          {targetKeyDesc}
        </li>
      ))}
    </ul>
  </>
)
TrackerServiceNames.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
}
const TrackerServiceTooltip = ({
  data,
  children,
  position = 'bottom center',
}) => (
  <Tooltip
    className="tooltip_basic ly_tooltip tooltip_pixelsdk"
    position={position}
    content={
      <>
        {data.mat && <TrackerServiceNames title="모먼트" data={data.mat} />}
        {data.plusfriend && (
          <TrackerServiceNames title="카카오톡 채널" data={data.plusfriend} />
        )}
        {data.talkstore && (
          <TrackerServiceNames title="톡스토어" data={data.talkstore} />
        )}
        {data.gift && <TrackerServiceNames title="선물하기" data={data.gift} />}
        {data.checkout && (
          <TrackerServiceNames title="톡체크아웃" data={data.checkout} />
        )}
        {data.web && <TrackerServiceNames title="웹사이트" data={data.web} />}
        {data.app && <TrackerServiceNames title="앱" data={data.app} />}
      </>
    }>
    {children}
  </Tooltip>
)
TrackerServiceTooltip.propTypes = {
  data: PropTypes.object.isRequired,
  children: PropTypes.node,
  position: PropTypes.string,
}
export default TrackerServiceTooltip
